/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_LookupInputs */

const cs_ares_lookup = /** @type {(inputs: Ares_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhledat`)
};

const en_ares_lookup = /** @type {(inputs: Ares_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Look up`)
};

/**
* | output |
* | --- |
* | "Look up" |
*
* @param {Ares_LookupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_lookup = /** @type {((inputs?: Ares_LookupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_LookupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_lookup(inputs)
	return cs_ares_lookup(inputs)
});